import { render, staticRenderFns } from "./Areas.vue?vue&type=template&id=69b30c6e&scoped=true"
import script from "./Areas.vue?vue&type=script&lang=js"
export * from "./Areas.vue?vue&type=script&lang=js"
import style0 from "./Areas.vue?vue&type=style&index=0&id=69b30c6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b30c6e",
  null
  
)

export default component.exports